function getRequiredObjectKeys(obj) {
    return Object.keys(obj);
}
export var DefaultsMergingPrefrence;
(function (DefaultsMergingPrefrence) {
    DefaultsMergingPrefrence[DefaultsMergingPrefrence["AlwaysTakeProps"] = 0] = "AlwaysTakeProps";
    DefaultsMergingPrefrence[DefaultsMergingPrefrence["TakeDefaultsForUndefinedProps"] = 1] = "TakeDefaultsForUndefinedProps";
})(DefaultsMergingPrefrence || (DefaultsMergingPrefrence = {}));
export function mergeWithDefaults(props, defaults, type = DefaultsMergingPrefrence.TakeDefaultsForUndefinedProps) {
    const propsWithDefaults = {
        ...defaults,
        ...props,
    };
    if (type === DefaultsMergingPrefrence.TakeDefaultsForUndefinedProps) {
        // This is almost complete but we want to ensure that a non undefined default
        for (const key of getRequiredObjectKeys(defaults)) {
            const value = defaults[key];
            if (value !== undefined && propsWithDefaults[key] == undefined) {
                propsWithDefaults[key] = value;
            }
        }
    }
    return propsWithDefaults;
}
//# sourceMappingURL=PropUtils.js.map